import React, { useState, useEffect, useRef } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   Button,
   Input,
   Grid,
   GridItem,
   useColorModeValue,
   Flex,
   Heading,
   Box,
   HStack,
   PinInput,
   PinInputField,
   Image,
   IconButton,
   Text,
} from '@chakra-ui/react';

import { useDispatch } from 'react-redux';
import { uploadDocument, sendVerifyOtp, deleteDocument, getAccount } from '../../../../../redux/actions/account';
import { deleteSalesDocument, uploadSalesDocument } from '../../../../../redux/actions/salesInvoice';
import { deletePurchaseDocument, uploadPurchaseDocument } from '../../../../../redux/actions/purchaseInvoice';
import { deleteIssueDocument, uploadIssueDocument } from '../../../../../redux/actions/issueInventory';
import { deleteReceiveDocument, uploadReceiveDocument } from '../../../../../redux/actions/receiveInventory';
import { hideMobileNumber } from 'utils/util';
import _ from 'lodash';
import { CloseIcon } from '@chakra-ui/icons';
import { getAccountById } from '../../../../../redux/actions/account';
import { useUser } from '../../../../../contexts';

const CustomerVerifyModal = ({
   isOpen,
   onClose,
   accountId,
   entryData,
   handleSubmit,
   mobile,
   account,
   isLoading,
   entryType,
   invoiceImages,
   setInvoiceImages,
}) => {
   const [file, setFile] = useState(null);
   const [docImages, setDocImages] = useState([]);
   const [userImages, setUserImages] = useState([]);
   // const [invoiceImages, setInvoiceImages] = useState([]);
   const [otp, setOtp] = useState(null);
   const [isSaveLoading, setIsSaveLoading] = useState(false); // Add loading state for save button
   const skipBtnRef = useRef(null);
   const dispatch = useDispatch();
   const { user } = useUser();

   useEffect(() => {
      if (isOpen && account) {
         const existingDocImages =
            account?.imagesLive?.docs?.map((url) => ({
               url,
               isExisting: true,
            })) || [];

         const existingUserImages =
            account?.imagesLive?.user?.map((url) => ({
               url,
               isExisting: true,
            })) || [];

         const existingInvoiceImages =
            entryData?.imagesLive?.bill?.map((url) => ({
               url,
               isExisting: true,
            })) || [];

         setDocImages(existingDocImages);
         setUserImages(existingUserImages);
         setInvoiceImages(existingInvoiceImages);
      }
   }, [isOpen, account]);

   const saveImage = async () => {
      // Prevent multiple clicks
      if (isSaveLoading) return;

      setIsSaveLoading(true); // Set loading to true when save starts

      const formData = new FormData();
      // const formData2 = new FormData();
      if (docImages.length > 0 || userImages.length > 0) {
         formData.append('id', accountId);
         docImages.forEach((imgObj) => {
            if (!imgObj.isExisting && imgObj.file) {
               formData.append('docs', imgObj.file);
            }
         });
         userImages.forEach((imgObj) => {
            if (!imgObj.isExisting && imgObj.file) {
               formData.append('user', imgObj.file);
            }
         });
      }

      // if (invoiceImages.length > 0) {
      //    formData2.append('id', entryData.id);
      //    invoiceImages.forEach((imgObj) => {
      //       if (!imgObj.isExisting && imgObj.file) {
      //          formData2.append('bill', imgObj.file);
      //       }
      //    });
      // }

      try {
         if (mobile && otp) {
            const res = await dispatch(sendVerifyOtp({ id: accountId, otp: Number(otp) }));
            if (res?.code === 1) {
               setFile(null);
               setOtp(null);
               handleSubmit();
               onClose();
            }
         }

         if (docImages?.length > 0 || userImages?.length > 0) {
            const response = await dispatch(uploadDocument(formData));

            if (response?.code === 1) {
               setFile(null);
               setOtp(null);
               setDocImages([]);
               setUserImages([]);
               handleSubmit();
               onClose();
            }
         }

         // if (invoiceImages?.length > 0) {
         //    let response = {};
         //    if (entryType === "sales") {
         //       response = await dispatch(uploadSalesDocument(formData2));
         //    } else if (entryType === "purchase") {
         //       response = await dispatch(uploadPurchaseDocument(formData2));
         //    } else if (entryType === "issue") {
         //       response = await dispatch(uploadIssueDocument(formData2));
         //    } else if (entryType === "receive") {
         //       response = await dispatch(uploadReceiveDocument(formData2));
         //    }
         //    if (response?.code === 1) {
         //       setFile(null);
         //       setOtp(null);
         //       setInvoiceImages([]);
         //       handleSubmit();
         //       onClose();
         //    }
         // }

         dispatch(
            getAccount({
               compId: Number(user?.loginhistory?.companyId),
               accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
               status: true,
            }),
         );
      } catch (error) {
         console.error('Error in saveImage:', error);
      } finally {
         setIsSaveLoading(false); // Reset loading state regardless of success or failure
      }
   };

   const handleSkip = _.debounce(() => {
      handleSubmit();
      setFile(null);
      setOtp(null);
      onClose();
   }, 500);

   useEffect(() => {
      if (isOpen && skipBtnRef.current) {
         skipBtnRef.current.focus();
      }
   }, [isOpen]);

   const handleImagesChange = (e, type) => {
      const files = Array.from(e.target.files);
      const currentImages = type === 'doc' ? docImages : type === 'user' ? userImages : invoiceImages;

      if (currentImages.length + files.length > 4) {
         alert(`Maximum 4 ${type === 'doc' ? 'Doc' : type === 'user' ? 'User' : 'invoice'} images allowed`);
         return;
      }

      const fileReaders = files.map((file) => {
         return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () =>
               resolve({
                  file,
                  preview: reader.result,
                  isExisting: false,
               });
            reader.readAsDataURL(file);
         });
      });

      Promise.all(fileReaders).then((newImages) => {
         if (type === 'doc') {
            setDocImages((prev) => [...prev, ...newImages]);
         } else if (type === 'user') {
            setUserImages((prev) => [...prev, ...newImages]);
         } else {
            setInvoiceImages((prev) => [...prev, ...newImages]);
         }
      });
   };

   const handleRemoveImage = async (type, index, img) => {
      if (img?.isExisting) {
         if (type === 'doc' || type === 'user') {
            await dispatch(deleteDocument({ id: String(accountId), imgName: img.url }));
         } else if (type === 'invoice') {
            if (entryType === 'sales') {
               await dispatch(deleteSalesDocument({ id: String(entryData.id), imgName: img.url }));
            } else if (entryType === 'purchase') {
               await dispatch(deletePurchaseDocument({ id: String(entryData.id), imgName: img.url }));
            } else if (entryType === 'issue') {
               await dispatch(deleteIssueDocument({ id: String(entryData.id), imgName: img.url }));
            } else if (entryType === 'receive') {
               await dispatch(deleteReceiveDocument({ id: String(entryData.id), imgName: img.url }));
            }
         }

         if (type === 'doc') {
            const updated = [...docImages];
            updated.splice(index, 1);
            setDocImages(updated);
         } else if (type === 'user') {
            const updated = [...userImages];
            updated.splice(index, 1);
            setUserImages(updated);
         } else {
            const updated = [...invoiceImages];
            updated.splice(index, 1);
            setInvoiceImages(updated);
         }

         if (type === 'doc' || type === 'user') {
            await dispatch(
               getAccount({
                  compId: Number(user?.loginhistory?.companyId),
                  accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                  status: true,
               }),
            );
         }
      } else {
         if (type === 'doc') {
            const updated = [...docImages];
            updated.splice(index, 1);
            setDocImages(updated);
         } else if (type === 'user') {
            const updated = [...userImages];
            updated.splice(index, 1);
            setUserImages(updated);
         } else {
            const updated = [...invoiceImages];
            updated.splice(index, 1);
            setInvoiceImages(updated);
         }
      }
   };

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered finalFocusRef={skipBtnRef}>
         <ModalOverlay />
         <ModalContent
            bg={useColorModeValue('white', '#2d3748')}
            color={useColorModeValue('gray.800', 'white')}
            borderRadius="20px"
            p={5}
            boxShadow="lg">
            <ModalHeader fontSize="20px" fontWeight="600" mb={4}>
               Customer Verification
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               <Box>
                  <Grid gap={2}>
                     <GridItem mb={3}>
                        <Text fontWeight="bold" mb={1}>
                           Upload User Images
                        </Text>
                        <Input
                           type="file"
                           multiple
                           name="userImages"
                           onChange={(e) => handleImagesChange(e, 'user')}
                           placeholder="Upload user images..."
                           pt={1}
                           accept="image/*"
                        />
                     </GridItem>
                     {userImages?.length > 0 && (
                        <Flex gap={4} wrap="wrap" mt={2}>
                           {userImages.map((img, index) => (
                              <Box key={index} position="relative" w="120px">
                                 <a
                                    href={img.isExisting ? img.url : img.preview}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'block' }}>
                                    <Image
                                       src={img.isExisting ? img.url : img.preview}
                                       alt={`User image ${index}`}
                                       crossOrigin="anonymous"
                                       boxSize="100px"
                                       objectFit="cover"
                                       borderRadius="md"
                                       border="1px solid"
                                       borderColor="gray.300"
                                       cursor="pointer"
                                       _hover={{ opacity: 0.8 }}
                                    />
                                 </a>
                                 <IconButton
                                    icon={<CloseIcon />}
                                    size="xs"
                                    colorScheme="red"
                                    position="absolute"
                                    top="-2"
                                    right="-2"
                                    onClick={() => handleRemoveImage('user', index, img)}
                                    borderRadius="full"
                                    aria-label="Remove user image"
                                 />
                              </Box>
                           ))}
                        </Flex>
                     )}
                     <GridItem mb={3}>
                        <Text fontWeight="bold" mb={1}>
                           Upload Doc Images
                        </Text>
                        <Input
                           type="file"
                           multiple
                           name="docImages"
                           onChange={(e) => handleImagesChange(e, 'doc')}
                           placeholder="Upload doc images..."
                           pt={1}
                           accept="image/*"
                        />
                     </GridItem>
                     {docImages?.length > 0 && (
                        <Flex gap={4} wrap="wrap" mt={2} mb={4}>
                           {docImages.map((img, index) => (
                              <Box key={index} position="relative" w="120px">
                                 <a
                                    href={img.isExisting ? img.url : img.preview}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'block' }}>
                                    <Image
                                       src={img.isExisting ? img.url : img.preview}
                                       alt={`Doc image ${index}`}
                                       crossOrigin="anonymous"
                                       boxSize="100px"
                                       objectFit="cover"
                                       borderRadius="md"
                                       border="1px solid"
                                       borderColor="gray.300"
                                       cursor="pointer"
                                       _hover={{ opacity: 0.8 }}
                                    />
                                 </a>
                                 <IconButton
                                    icon={<CloseIcon />}
                                    size="xs"
                                    colorScheme="red"
                                    position="absolute"
                                    top="-2"
                                    right="-2"
                                    onClick={() => handleRemoveImage('doc', index, img)}
                                    borderRadius="full"
                                    aria-label="Remove doc image"
                                 />
                              </Box>
                           ))}
                        </Flex>
                     )}
                     <GridItem mb={3}>
                        <Text fontWeight="bold" mb={1}>
                           Upload Invoice Images
                        </Text>
                        <Input
                           type="file"
                           multiple
                           name="invoiceImage"
                           onChange={(e) => handleImagesChange(e, 'invoice')}
                           placeholder="Upload invoice images..."
                           pt={1}
                           accept="image/*"
                        />
                     </GridItem>
                     {invoiceImages?.length > 0 && (
                        <Flex gap={4} wrap="wrap" mt={2}>
                           {invoiceImages.map((img, index) => (
                              <Box key={index} position="relative" w="120px">
                                 <a
                                    href={img.isExisting ? img.url : img.preview}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'block' }}>
                                    <Image
                                       src={img.isExisting ? img.url : img.preview}
                                       alt={`Invoice image ${index}`}
                                       crossOrigin="anonymous"
                                       boxSize="100px"
                                       objectFit="cover"
                                       borderRadius="md"
                                       border="1px solid"
                                       borderColor="gray.300"
                                       cursor="pointer"
                                       _hover={{ opacity: 0.8 }}
                                    />
                                 </a>
                                 <IconButton
                                    icon={<CloseIcon />}
                                    size="xs"
                                    colorScheme="red"
                                    position="absolute"
                                    top="-2"
                                    right="-2"
                                    onClick={() => handleRemoveImage('invoice', index, img)}
                                    borderRadius="full"
                                    aria-label="Remove Invoice image"
                                 />
                              </Box>
                           ))}
                        </Flex>
                     )}
                  </Grid>
               </Box>
               {mobile ? (
                  <Box my={5}>
                     <Heading as="h3" size="md" mb={5}>
                        Verify By OTP
                     </Heading>
                     <Grid gap={2}>
                        <GridItem>
                           <Flex gap={3}>
                              <Input
                                 type="text"
                                 value={hideMobileNumber(mobile)}
                                 placeholder="Enter Mobile No."
                                 pt={1}
                                 isDisabled
                              />
                              <Button
                                 colorScheme="blue"
                                 variant="solid"
                                 onClick={() => dispatch(sendVerifyOtp({ id: accountId }))}>
                                 Send OTP
                              </Button>
                           </Flex>
                        </GridItem>
                        <GridItem>
                           <HStack>
                              <PinInput defaultValue="" onChange={(value) => setOtp(value)}>
                                 <PinInputField />
                                 <PinInputField />
                                 <PinInputField />
                                 <PinInputField />
                                 <PinInputField />
                                 <PinInputField />
                              </PinInput>
                           </HStack>
                        </GridItem>
                     </Grid>
                  </Box>
               ) : null}
            </ModalBody>
            <ModalFooter justifyContent="flex-end" alignItems="center">
               <Flex gap={3}>
                  <Button
                     ref={skipBtnRef}
                     colorScheme="blue"
                     variant="ghost"
                     onClick={() => handleSkip()}
                     _focus={{ outlineColor: 'blue.500' }}
                     autoFocus
                     isLoading={isLoading}
                     disabled={isLoading || isSaveLoading} // Disable skip when save is loading
                  >
                     Skip
                  </Button>
                  <Button
                     colorScheme="green"
                     variant="solid"
                     onClick={() => saveImage()}
                     _focus={{ outlineColor: 'blue.500' }}
                     isLoading={isSaveLoading} // Add loading state to save button
                     loadingText="Saving..." // Optional: Custom loading text
                     disabled={
                        isSaveLoading || // Disable when loading
                        (docImages?.length > 0 || userImages?.length > 0 || (otp && otp.length === 6) ? false : true)
                     }>
                     Save
                  </Button>
                  <Button
                     colorScheme="red"
                     variant="solid"
                     onClick={() => onClose()}
                     _focus={{ outlineColor: 'blue.500' }}
                     disabled={isSaveLoading} // Disable cancel when save is loading
                  >
                     Cancel
                  </Button>
               </Flex>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default CustomerVerifyModal;
